import React from "react";
import Voucher from "./voucherWrapper/Voucher";

export default function VoucherWrapper({history, CHECK_VOUCHER, voucher}){
    let props = {
        history,
        CHECK_VOUCHER,
        voucher
    };

    return (
        <Voucher props={props}  />
    );
}


// WEBPACK FOOTER //
// ./src/components/general/VoucherWrapper.jsx